import { Alert, Platform } from 'react-native'
import { isWeb, getPlatform } from '../utils/platformUtils'
import { getDatabaseAdapter, initializeDatabaseAdapter } from './DatabaseAdapter'
import {
    LEARNING_STORE_NAMES,
    PORTFOLIO_STORE_NAMES,
    BENEFITS_STORE_NAMES,
    SCHEDULES_STORE_NAMES,
    POST_TABLE_NAMES,
    GAMIFICATION_STORE_NAMES,
    DOTI_MESSAGES,
} from './constants'

// Debug: Las constantes se importan correctamente - removed logs
// Avoid importing from database modules to prevent cycles
import * as FileSystem from 'expo-file-system/legacy'
const dbName = 'myDB'
const postsStoreName = 'posts'
const versionsStoreName = 'versions'
export const USER_PROFILE = 'user_profiles'
const REACTIONS = 'reactions'
const FOOTER_APP = 'footer_app'
// const learningStoreName = 'learnings'
import { getAppVersion } from '../components/customUtils/AppConstants'
import { VERSION_DATABASE } from '../config/config'
// Removed resetCache import to break circular dependency
// import { resetCache } from '../utils/FetchServices'
import { TABLE_ERROR_LOGS } from './constants'

import { STATUS_FORM_PENDING_SYNC } from '../components/stores/constants/constants.stores'

let db
let database_instance = null
let native_initialized = false

import { database_next } from '../../database/open.database.new.js'
import { TABLE_NAME, TABLES_ARRAY } from '../../db-sqlite/constants/tables'

export const DATABASE_CONFIG = {
    NAME_DB: dbName,
    VERSION: VERSION_DATABASE, //getAppVersion(), //toma la version de la app
}

// Internal helper to create or get universal DB and ensure schema
const createOrGetNativeDB = async (update = false) => {
    // console.log(`🔧 Initializing database adapter... update=${update}`)
    if (database_instance && !update) {
        return database_instance
    }

    try {
        // Use universal database adapter
        database_instance = await initializeDatabaseAdapter(dbName)
        console.log(`✅ 1Database adapter initialized for ${Platform.OS}`)

        // Run schema creation only once unless forced via update
        if (!native_initialized || update) {
            try {
                // Create all tables using universal adapter
                await database_instance.execAsync(
                    `CREATE TABLE IF NOT EXISTS ${versionsStoreName} (serviceName TEXT PRIMARY KEY, value INTEGER);`,
                )

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${postsStoreName} (
                    _id TEXT PRIMARY KEY,
                    date_publish TEXT,
                    date_publish_date TEXT,
                    description_long TEXT,
                    description_short TEXT,
                    labels TEXT,
                    liked BOOLEAN,
                    link_share TEXT,
                    medias TEXT,
                    likes_counter INTEGER,
                    publication_date TEXT,
                    reaction_counter TEXT,
                    reactions TEXT,
                    title TEXT,
                    go_to TEXT,
                    complete BOOLEAN,
                    status_favourite INTEGER,
                    views INTEGER,
                    post_height INTEGER,
                    comment_count INTEGER,
                    isPinned BOOLEAN DEFAULT 0
                );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${LEARNING_STORE_NAMES.CATEGORIES} (
                    _id TEXT PRIMARY KEY,
                    category_name TEXT,
                    description TEXT,
                    cover_image TEXT,
                    channel_icon TEXT,
                    action TEXT,
                    blocked_by TEXT,
                    repository TEXT,
                    category_home TEXT,
                    status INTEGER,
                    category_index INTEGER
                );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${LEARNING_STORE_NAMES.COURSES} (
                    _id TEXT PRIMARY KEY,
                    blocked_by TEXT,
                    date TEXT,
                    title TEXT,
                    cover_image TEXT,
                    description_short TEXT,
                    description_long TEXT,
                    share BOOLEAN,
                    progressive_mode BOOLEAN,
                    likes INTEGER,
                    evaluations TEXT,
                    type TEXT,
                    moduls TEXT,
                    status_liked BOOLEAN,
                    status INTEGER,
                    category_id TEXT,
                    assessmentResult TEXT,
                    course_index INTEGER,
                    certificate TEXT,
                    download_zip TEXT
                );`)

                // Learning extra tables
                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${LEARNING_STORE_NAMES.CONTENTS} (
                _id TEXT PRIMARY KEY,
                evaluations TEXT,
                course_name TEXT,
                media TEXT,
                content_type TEXT,
                title TEXT,
                description_short BOOLEAN,
                description_long TEXT,
                media_slides TEXT,
                link_share TEXT,
                status INTEGER,
                assessmentResult TEXT,
                cover_image TEXT,
                certificate TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${LEARNING_STORE_NAMES.EVALUATIONS} (
                _id TEXT PRIMARY KEY,
                name TEXT,
                can_repeat TEXT,
                can_repeat_failure TEXT,
                can_repeat_success TEXT,
                type_assessment TEXT,
                questions TEXT,
                count_questions TEXT,
                questions_random BOOLEAN,
                assessmentResult TEXT,
                survey TEXT,
                approval_rate TEXT,
                allow_partial_submission BOOLEAN,
                max_retry_attempts INTEGER,
                retry_only_failed BOOLEAN,
                attempts_count INTEGER,
                failed_questions TEXT,
                partial_anmswers TEXT,
                attempt_expiry_days INTEGER,
                attempt_expiry_minutes INTEGER,
                attempt_reset_days INTEGER,
                attempt_reset_minutes INTEGER,
                attempt_date_created TEXT,
                current_attempt_id TEXT
            );`)

                // Backward-compat: algunos insert antiguos usan la columna 'random'.
                // Agregamos la columna si no existe para evitar errores de inserción legacy.
                try {
                    await database_instance.execAsync(
                        `ALTER TABLE ${LEARNING_STORE_NAMES.EVALUATIONS} ADD COLUMN random BOOLEAN;`,
                    )
                } catch (e) {
                    // Ignorar si ya existe o si la BD no permite ALTER redundante
                }

                try {
                    await database_instance.execAsync(
                        `CREATE TABLE IF NOT EXISTS ${PORTFOLIO_STORE_NAMES.CATEGORIES} (
                    _id TEXT PRIMARY KEY,
                    name TEXT,
                    description_short TEXT,
                    description_long TEXT,
                    image TEXT,
                    categories TEXT,
                    products TEXT,
                    father_id TEXT,
                    categoy_index INTEGER,
                    level INTEGER,
                    brands STRING,
                    index_category INTEGER
                    );`,
                    )
                    await database_instance.execAsync(
                        `CREATE TABLE IF NOT EXISTS ${PORTFOLIO_STORE_NAMES.PRODUCTS} (
                    _id TEXT PRIMARY KEY,
                    name TEXT,
                    description_short TEXT,
                    description_long TEXT,
                    brand TEXT,
                    category_id TEXT,
                    medias TEXT,
                    ean TEXT,
                    sku TEXT,
                    download_links TEXT,
                    index_product INTEGER
                    );`,
                    )

                    await database_instance.execAsync(
                        `CREATE TABLE IF NOT EXISTS ${PORTFOLIO_STORE_NAMES.BRANDS} (
                        _id TEXT PRIMARY KEY,
                        status INTEGER,
                        name TEXT,
                        image TEXT,
                        index_brand INTEGER
                       );`,
                    )
                } catch (e) {
                    console.error(
                        'Error al agregar columna random a evaluaciones:',
                        e,
                    )
                }

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${LEARNING_STORE_NAMES.ANSWERS_EVALUATIONS} (
                _id INTEGER PRIMARY KEY,
                course_id TEXT,
                content_id TEXT,
                evaluation_id TEXT,
                answers TEXT,
                status INTEGER DEFAULT 0
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${LEARNING_STORE_NAMES.SAVE_PROGRESS_TRAINING} (
                _id TEXT PRIMARY KEY,
                status INTEGER,
                moduls TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${USER_PROFILE} (
                    _id TEXT PRIMARY KEY,
                    name TEXT,
                    last_name TEXT,
                    email TEXT,
                    user_name TEXT,
                    role TEXT,
                    avatar TEXT,
                    timeZone TEXT,
                    user_segment TEXT,
                    name_group TEXT,
                    ws_url TEXT,
                    delete_active TEXT,
                    lat REAL,
                    lng REAL,
                    url_uploads TEXT,
                    languages TEXT,
                    lenguage TEXT,
                    phone TEXT,
                    email_verified BOOLEAN,
                    phone_verified BOOLEAN,
                    cognito_id TEXT,
                    login BOOLEAN,
                    image_splash TEXT,
                    last_update_coords TEXT,
                    area TEXT,
                    nickname TEXT,
                    dni TEXT
                );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${LEARNING_STORE_NAMES.ANSWERS_SURVEY} (
                _id TEXT PRIMARY KEY,
                post_id TEXT,
                course_id TEXT,
                survey_id TEXT,
                answers TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${REACTIONS} (
                _id TEXT PRIMARY KEY,
                reactions_count INTEGER,
                reactions_index INTEGER,
                name TEXT,
                isSelected BOOLEAN
            );`)

                // Benefits
                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${BENEFITS_STORE_NAMES.BENEFIT_VOUCHERS} (
                _id TEXT PRIMARY KEY,
                cover_image TEXT,
                description_short TEXT,
                description_long TEXT,
                points TEXT,
                title TEXT,
                terms_and_conditions TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${BENEFITS_STORE_NAMES.REDEEMS} (
                _id TEXT PRIMARY KEY,
                name TEXT,
                points TEXT,
                status INTEGER,
                date TEXT,
                image TEXT,
                user_id TEXT,
                user_name TEXT,
                modification_date TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${BENEFITS_STORE_NAMES.POINTS_AWARDED} (
                _id TEXT PRIMARY KEY,
                type TEXT,
                type_text TEXT,
                date TEXT,
                status INTEGER,
                points INTEGER,
                id_user TEXT,
                name_user TEXT,
                code_user TEXT,
                name TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${FOOTER_APP} (
                _id TEXT PRIMARY KEY,
                label TEXT,
                icon TEXT,
                nav BOOLEAN,
                section BOOLEAN,
                name TEXT,
                index_footer INTEGER
            );`)

                // Schedules core tables
                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.STORES} (
                _id TEXT PRIMARY KEY,
                name TEXT,
                address TEXT,
                lat REAL,
                lng REAL,
                code TEXT,
                cluster TEXT,
                area TEXT,
                region TEXT,
                format TEXT,
                flag TEXT,
                maximum_distance_for_checkin INTEGER,
                segment TEXT,
                distributor_id,
                existsInDB BOOLEAN,
                _id_mongoDB TEXT,
                organization_id TEXT,
                status_send INTEGER,
                frequency TEXT,
                topstore TEXT,
                potencial TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${POST_TABLE_NAMES.VIEWED_POSTS} (
                _id TEXT PRIMARY KEY,
                date TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.FORMS} (
                _id TEXT PRIMARY KEY,
                index_form INTEGER,
                repeat BOOLEAN,
                can_repeat BOOLEAN,
                icon TEXT,
                check_in BOOLEAN,
                name_form TEXT,
                icon_check TEXT,
                type_form TEXT,
                contents TEXT,
                segments TEXT,
                status INTEGER,
                progress BOOLEAN,
                totalScore INTEGER,
                show_barcode BOOLEAN,
                tags TEXT,
                wise BOOLEAN,
                heladera BOOLEAN,
                create_refrigerator BOOLEAN,
                form_id_father TEXT,
                start_ejecution TEXT,
                end_ejecution TEXT,
                link TEXT,
                objective BOOLEAN,
                weigh FLOAT,
                scores TEXT,
                weights TEXT,
                sub_title TEXT,
                description TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.CAMPAINGS} (
                _id TEXT PRIMARY KEY,
                name TEXT,
                code TEXT,
                image TEXT,
                date_init TEXT,
                date_finish TEXT,
                steps TEXT,
                total_progres INTEGER,
                schedules TEXT,
                camp_values TEXT,
                schedule_free BOOLEAN,
                date_moderation_init TEXT,
                date_moderation_finish TEXT,
                moderation BOOLEAN,
                campaing_subtitle TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.SCHEDULES} (
                _id TEXT PRIMARY KEY,
                date_init TEXT,
                date_finish TEXT,
                form_finish TEXT,
                form_init TEXT,
                stores TEXT,
                campaign_id TEXT,
                progress_diary BOOLEAN,
                additional STRING,
                activities STRING,
                others_activities STRING,
                distributor STRING,
                vacation BOOLEAN,
                activities_advances STRING,
                others_activities_advances STRING,
                forms_additionals STRING,
                forms_incidence STRING,
                reports STRING,
                data_version INTEGER
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                repeat BOOLEAN,
                date_init TEXT,
                date_finish TEXT,
                schedule_id TEXT,
                form_id TEXT,
                status INTEGER,
                store_id TEXT,
                answers TEXT,
                questions TEXT,
                progress BOOLEAN,
                totalScore INTEGER,
                scoreObtained INTEGER,
                cant_questions_yes_na INTEGER,
                progress_questions_yes_na INTEGER,
                scoreTotalQuestionsPonderar INTEGER,
                name_form TEXT, 
                heladera BOOLEAN,
                create_refrigerator BOOLEAN, 
                type_form TEXT,
                form_id_father TEXT,
                status_send INTEGER,
                checkout BOOLEAN,
                day_unique_id TEXT,
                checkin_id TEXT,
                scoreTotalQuestionsPonderarFloat FLOAT,
                scoreObtainedFloat FLOAT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.SCHEDULES_POS} (
                _id TEXT PRIMARY KEY,
                store_id TEXT,
                schedule_id TEXT,
                forms_relevant TEXT,
                forms_featured TEXT,
                forms TEXT,
                campaign_status INTEGER,
                lat REAL,
                lng REAL,
                existsInDB BOOLEAN,
                status_send INTEGER
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES} (
                _id TEXT PRIMARY KEY,
                pos_id TEXT,
                schedule_id TEXT,
                forms TEXT,
                status INTEGER,
                date_init TEXT,
                form_id TEXT,
                progress TEXT,
                checkin_id TEXT,
                date_modified TEXT,
                distributor_id TEXT,
                score TEXT,
                objectives TEXT,
                incidence_answer TEXT,
                last_checkout TEXT,
                score_global REAL
            );`)

                // Checkin/out and steps
                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.CHECKIN} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                date TEXT,
                store_id TEXT,
                lat_checkin TEXT,
                lng_checkin TEXT,
                checkin_id TEXT,
                schedule_id TEXT,
                date_init TEXT,
                dif_utc TEXT,
                status INTEGER,
                activities TEXT,
                others_activities TEXT,
                distributor_id TEXT,
                objectives TEXT,
                steps_distributor TEXT,
                formsIdsFqa TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.CHECKIN_STEPS} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                date TEXT,
                store_id TEXT,
                schedule_id TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.CHECKOUT} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                date TEXT,
                store_id TEXT,
                lat_checkout TEXT,
                lng_checkout TEXT,
                checkout_id TEXT,
                checkin_id TEXT,
                schedule_id TEXT,
                date_finish TEXT,
                checkin_id_local TEXT,
                dif_utc TEXT,
                status INTEGER,
                distributor_id TEXT,
                forms_view TEXT,
                steps_distributor TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.SCHEDULE_ACTIVITIES_ADVANCES} (
                _id TEXT PRIMARY KEY,
                date TEXT,
                schedule_id TEXT,
                activities TEXT,
                status INTEGER
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.SCHEDULE_ACTIVITIES_ADVANCES_PENDINGS} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                schedule_id TEXT,
                checkin_id TEXT,
                activities TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.FORMS_ADDITIONALS} (
                _id TEXT PRIMARY KEY,
                title TEXT,
                date TEXT,
                date_finish TEXT,
                icon TEXT,
                questions TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.CREATE_STORES} (
                _id TEXT PRIMARY KEY,
                forms TEXT,
                areas TEXT,
                maximum_distance_for_checkin INTEGER
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.FORMS_PERFECT_STORE} (
                _id TEXT PRIMARY KEY,
                status INTEGER,
                form_index INTEGER,
                title TEXT,
                icon TEXT,
                medias TEXT,
                type TEXT,
                start_ejecution TEXT,
                end_ejecution TEXT,
                tags TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.STORES_PF_RELATION} (
                _id TEXT PRIMARY KEY,
                pos_id INTEGER,
                forms_id TEXT
            );`)

                // Error logs
                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${TABLE_ERROR_LOGS} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                user_id TEXT,
                log TEXT,
                date TEXT,
                connect_status TEXT,
                endpoint TEXT,
                additional TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.UPLOAD_IMAGES_PENDING} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                filename TEXT,
                pickerResult_uri TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.FORMS_TOTALS} (
                _id TEXT PRIMARY KEY,
                schedule_id TEXT,
                name TEXT,
                count INTEGER,
                count_of_done INTEGER
            );`)

                // Tracking events table used by database/tracking.database.js
                try {
                    const { TRACKINGS } = require('../../database/tracking.database')
                    await database_instance.execAsync(
                        `CREATE TABLE IF NOT EXISTS ${TRACKINGS.TRACKINGS} (
                        _id INTEGER PRIMARY KEY AUTOINCREMENT,
                        content_id TEXT,
                        date_interaction_init TEXT,
                        type_interaction TEXT,
                        name_table TEXT
                    );`,
                    )
                } catch (error) {
                    console.error('Error creating TRACKINGS table:', error)
                }

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.ASSETS_PF_LINKS} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                indexRoute INTEGER,
                status INTEGER,
                rute TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.STORES_CREATE_FIELDS} (
                _id TEXT PRIMARY KEY,
                name TEXT UNIQUE,
                title TEXT UNIQUE,
                type TEXT NOT NULL,
                required INTEGER NOT NULL, 
                dependency TEXT,           
                placeholder TEXT,
                options TEXT,              
                optionsFrom TEXT,
                configure TEXT,
                validate_unique INTEGER NOT NULL DEFAULT 0,
                table_name TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.STORES_CREATE_FIELDS_ORGANIZATIONS} (
                _id TEXT PRIMARY KEY,
                name TEXT UNIQUE,
                title TEXT UNIQUE,
                type TEXT NOT NULL,
                required INTEGER NOT NULL, 
                dependency TEXT,           
                placeholder TEXT,
                options TEXT,              
                optionsFrom TEXT,
                configure TEXT,
                validate_unique INTEGER NOT NULL DEFAULT 0,
                table_name TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.STORES_CREATE_COUNTRIES} (
                _id TEXT PRIMARY KEY,
                prefix TEXT NOT NULL,
                name TEXT NOT NULL,
                geo_code TEXT NOT NULL         
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.STORES_CREATE_PROVINCES} (
                _id TEXT PRIMARY KEY,
                name TEXT NOT NULL,
                country_id TEXT NOT NULL
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.STORES_CREATE_CITIES} (
                _id TEXT PRIMARY KEY,
                name TEXT NOT NULL,
                province_id TEXT NOT NULL,
                country_id TEXT NOT NULL
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.STORES_ORGANIZATIONS} (
                _id TEXT PRIMARY KEY,
                name TEXT,
                cuit TEXT,
                code TEXT,
                status_send INTEGER
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.STORES_PENDING_SEND} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                data_send TEXT,
                data_match TEXT
            );`)

                // Gamification
                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${GAMIFICATION_STORE_NAMES.GAME_PENDING_SEND} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                game_id TEXT,
                level_id TEXT,
                status INTEGER,
                body TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.FORMS_PENDING_SYNC} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                activity_id TEXT,
                status INTEGER,
                date TEXT,
                count INTEGER DEFAULT 1,
                form_name TEXT,
                status_send INTEGER DEFAULT ${STATUS_FORM_PENDING_SYNC.NO_SENDED},
                schedule_id TEXT,
                store_id TEXT,
                checkin_id TEXT,
                can_send BOOLEAN DEFAULT 1
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${SCHEDULES_STORE_NAMES.STORES_INDICATORS} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                store_id TEXT,
                indicators TEXT
            );`)
                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${DOTI_MESSAGES} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                role TEXT,
                content TEXT,
                timestamp TEXT,
                type TEXT,
                'values' TEXT
            );`)

                await database_instance.execAsync(`CREATE TABLE IF NOT EXISTS ${TABLE_NAME.DOTI_SUGGESTED_QUESTIONS} (
                _id INTEGER PRIMARY KEY AUTOINCREMENT,
                question TEXT
            );`)

                native_initialized = true
                console.log('✅ Database tables created successfully')
            } catch (e) {
                console.error('❌ Error creating database tables:', e)
                throw e
            }
        }

        return database_instance
    } catch (error) {
        console.error('❌ Failed to initialize database adapter:', error)
        throw error
    }
}

export const openDB = async (update) => {
    return new Promise(async (resolve, reject) => {
        try {
            // console.log(`🔧 Opening database (update: ${update})...`)

            // Use the universal database adapter instead of platform-specific code
            const db = await createOrGetNativeDB(update)

            // console.log(`✅ Database opened successfully for ${Platform.OS}`)
            resolve(db)
        } catch (error) {
            console.error('❌ Failed to open database:', error)
            reject(error)
        }
    })
}

// Synchronous getter for native modules to reuse the same DB and ensured schema
export const getNativeDB = () => {
    if (isWeb()) {
        return {
            transaction: () => ({ executeSql: () => {} }),
            execSync: () => {},
            prepareSync: () => ({
                executeSync: () => ({
                    getAllSync: () => [],
                    getFirstSync: () => null,
                }),
                finalizeSync: () => {},
            }),
        }
    }

    // ✅ Usar DatabaseSingleton en lugar de openDatabaseSync directo
    try {
        if (!db) {
            const DatabaseSingleton =
                require('../../database-sqlite/DatabaseSingleton').default
            db = DatabaseSingleton.getInstance()
        }

        return {
            execSync: (sql) => {
                try {
                    return db.execSync ? db.execSync(sql) : null
                } catch (e) {
                    return null
                }
            },
            runSync: (sql, params = []) => {
                try {
                    return db.runSync
                        ? db.runSync(sql, params)
                        : { changes: 0, insertId: null }
                } catch (e) {
                    return { changes: 0, insertId: null }
                }
            },
            getAllSync: (sql, params = []) => {
                try {
                    return db.getAllSync ? db.getAllSync(sql, params) : []
                } catch (e) {
                    return []
                }
            },
            getFirstSync: (sql, params = []) => {
                try {
                    return db.getFirstSync ? db.getFirstSync(sql, params) : null
                } catch (e) {
                    return null
                }
            },
            prepareSync: (sql) => ({
                getFirstSync: (params = []) => {
                    try {
                        return db.getFirstSync ? db.getFirstSync(sql, params) : null
                    } catch (e) {
                        return null
                    }
                },
                getAllSync: (params = []) => {
                    try {
                        return db.getAllSync ? db.getAllSync(sql, params) : []
                    } catch (e) {
                        return []
                    }
                },
                executeSync: (params = []) => {
                    try {
                        return db.runSync
                            ? db.runSync(sql, params)
                            : { changes: 0, insertId: null }
                    } catch (e) {
                        return { changes: 0, insertId: null }
                    }
                },
                finalizeSync: () => {},
            }),
        }
    } catch (error) {
        return {
            execSync: () => null,
            runSync: () => ({ changes: 0, insertId: null }),
            getAllSync: () => [],
            getFirstSync: () => null,
            prepareSync: () => ({
                getFirstSync: () => null,
                getAllSync: () => [],
                executeSync: () => ({ changes: 0, insertId: null }),
                finalizeSync: () => {},
            }),
        }
    }
}

export const addPost = async (db, post) => {
    if (isWeb()) {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([postsStoreName], 'readwrite')
            const objectStore = transaction.objectStore(postsStoreName)

            const request = objectStore.add(post)

            request.onsuccess = () => {
                resolve()
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        })
    } else {
        try {
            const database = await createOrGetNativeDB()
            const result = await database.execAsync(
                `INSERT INTO ${postsStoreName} (
                _id, date_publish, date_publish_date, description_long, description_short,
                labels, liked, link_share, medias, likes_counter, publication_date,
                reaction_counter, reactions, title, go_to, complete, status_favourite, views
            ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
                [
                    post._id,
                    post.date_publish,
                    post.date_publish_date,
                    post.description_long,
                    post.description_short,
                    post.labels,
                    post.liked ? 1 : 0,
                    post.link_share,
                    JSON.stringify(post.medias),
                    post.likes_counter,
                    post.publication_date,
                    post.reaction_counter,
                    JSON.stringify(post.reactions),
                    post.title,
                    post.go_to,
                    post.complete ? 1 : 0,
                    post.status_favourite,
                    post.views,
                ],
            )

            return result
        } catch (error) {
            console.error('Error adding post:', error)
            throw error
        }
    }
}

export const getPosts = async (db, limit = 10) => {
    if (isWeb()) {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([postsStoreName], 'readonly')
            const objectStore = transaction.objectStore(postsStoreName)
            const request = objectStore.getAll()

            request.onsuccess = () => {
                resolve(request.result.slice(0, limit))
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        })
    } else {
        try {
            const database = await createOrGetNativeDB()
            const posts = await database.getAllAsync(
                `SELECT * FROM ${postsStoreName} ORDER BY isPinned DESC, publication_date DESC LIMIT ?`,
                [limit],
            )
            return posts
        } catch (error) {
            console.error('Error getting posts:', error)
            throw error
        }
    }
}

export const getAllPosts = async (db, offset = 0, limit = -1) => {
    if (isWeb()) {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([postsStoreName], 'readonly')
            const objectStore = transaction.objectStore(postsStoreName)
            const request = objectStore.getAll()

            request.onsuccess = () => {
                const posts = request.result
                const result =
                    limit === -1
                        ? posts.slice(offset)
                        : posts.slice(offset, offset + limit)
                resolve(result)
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        })
    } else {
        try {
            const database = await createOrGetNativeDB()
            let query = `SELECT * FROM ${postsStoreName} ORDER BY isPinned DESC, publication_date DESC`
            const params = []

            if (limit !== -1) {
                query += ` LIMIT ?`
                params.push(limit)
            }

            if (offset > 0) {
                query += ` OFFSET ?`
                params.push(offset)
            }

            const posts = await database.getAllAsync(query, params)
            return posts.map(parsePostJsonColumns)
        } catch (error) {
            console.error('Error getting all posts:', error)
            return []
        }
    }
}

// El backend a veces devuelve un único objeto en vez de un array de un elemento
// (ej: medias/labels con un solo item). Normalizamos siempre a array para que
// los componentes que hacen .map/.forEach/.length no truenen con esa forma.
const parseJsonAsArray = (value, fallback = []) => {
    try {
        const parsed = JSON.parse(value)
        if (Array.isArray(parsed)) return parsed
        if (parsed == null) return fallback
        return [parsed]
    } catch {
        return fallback
    }
}

// Las columnas medias/labels/go_to/reactions se guardan como texto JSON en SQLite;
// getAllAsync devuelve las filas crudas, hay que parsearlas antes de usarlas en la UI.
const parsePostJsonColumns = (post) => {
    let go_to = null
    try {
        go_to = JSON.parse(post.go_to)
    } catch {
        go_to = null
    }

    return {
        ...post,
        medias: parseJsonAsArray(post.medias),
        labels: parseJsonAsArray(post.labels),
        reactions: parseJsonAsArray(post.reactions),
        go_to,
    }
}

// Global version management functions
export const getGlobalVersion = async (db, serviceName) => {
    if (isWeb()) {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([versionsStoreName], 'readonly')
            const objectStore = transaction.objectStore(versionsStoreName)
            const request = objectStore.get(serviceName)

            request.onsuccess = () => {
                const result = request.result
                resolve(result ? result.value : null)
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        })
    } else {
        try {
            const database = await createOrGetNativeDB()
            const version = await database.getFirstAsync(
                `SELECT value FROM ${versionsStoreName} WHERE serviceName = ?`,
                [serviceName],
            )
            return version ? version.value : null
        } catch (error) {
            console.error('Error getting global version:', error)
            return null
        }
    }
}

/**
 * @deprecated utilizar updateGlobalVersion de user.repository para mantener la lógica centralizada y evitar inconsistencias entre indexDB y SQLite
 */
export const updateGlobalVersion = async (db, serviceName, version) => {
    const userRepository =
        await import('../../db-sqlite/repositories/user.repository')

    return userRepository.updateGlobalVersion(serviceName, version)

    // if (isWeb()) {
    //     return new Promise((resolve, reject) => {
    //         const transaction = db.transaction([versionsStoreName], 'readwrite')
    //         const objectStore = transaction.objectStore(versionsStoreName)
    //         const request = objectStore.put({ serviceName, value: version })

    //         request.onsuccess = () => {
    //             resolve()
    //         }

    //         request.onerror = (event) => {
    //             reject(event.target.error)
    //         }
    //     })
    // } else {
    //     try {
    //         const database = await createOrGetNativeDB()
    //         await database.execAsync(
    //             `INSERT OR REPLACE INTO ${versionsStoreName} (serviceName, value) VALUES (?, ?)`,
    //             [serviceName, version],
    //         )
    //     } catch (error) {
    //         console.error('Error updating global version:', error)
    //         throw error
    //     }
    // }
}

// User management functions
export const addUser = async (db, user) => {
    const userRepository =
        await import('../../db-sqlite/repositories/user.repository')

    return userRepository.upsertUser(user)
    // if (isWeb()) {
    //     return new Promise((resolve, reject) => {
    //         const transaction = db.transaction([USER_PROFILE], 'readwrite')
    //         const objectStore = transaction.objectStore(USER_PROFILE)
    //         const request = objectStore.put(user)

    //         request.onsuccess = () => resolve()
    //         request.onerror = (event) => reject(event.target.error)
    //     })
    // } else {
    //     try {
    //         const toSqlValue = (value, defaultValue = '') => {
    //             if (value === null || value === undefined) return defaultValue === '' ? defaultValue : null
    //             if (value instanceof Date) return value.toISOString()
    //             if (typeof value === 'boolean') return value ? 1 : 0
    //             if (typeof value === 'number') return value
    //             if (typeof value === 'object') return JSON.stringify(value)
    //             return String(value)
    //         }

    //         const values = [
    //             toSqlValue(user._id, ''),
    //             toSqlValue(user.name, ''),
    //             toSqlValue(user.last_name, ''),
    //             toSqlValue(user.email, ''),
    //             toSqlValue(user.user_name, ''),
    //             toSqlValue(user.role, ''),
    //             toSqlValue(user.avatar, ''),
    //             toSqlValue(user.timeZone, ''),
    //             toSqlValue(user.user_segment, '{}'), // Objeto → JSON
    //             toSqlValue(user.name_group, ''),
    //             toSqlValue(user.ws_url, ''),
    //             toSqlValue(user.delete_active, ''), // Boolean → string
    //             user.lat !== null && user.lat !== undefined ? Number(user.lat) : 0,
    //             user.lng !== null && user.lng !== undefined ? Number(user.lng) : 0,
    //             toSqlValue(user.url_uploads, ''),
    //             toSqlValue(user.languages, '[]'), // Array → JSON
    //             toSqlValue(user.lenguage, ''),
    //             toSqlValue(user.phone, ''),
    //             user.email_verified ? 1 : 0, // Boolean → number
    //             user.phone_verified ? 1 : 0, // Boolean → number
    //             toSqlValue(user.cognito_id, ''),
    //             user.login ? 1 : 0, // Boolean → number
    //             toSqlValue(user.image_splash, ''),
    //             toSqlValue(user.last_update_coords, ''),
    //             toSqlValue(user.area, ''),
    //             toSqlValue(user.nickname, ''),
    //             toSqlValue(user.dni, ''),
    //         ]

    //         console.log(`[addUser] Validando ${values.length} valores...`)

    //         values.forEach((v, i) => {
    //             const type = typeof v
    //             const isValid = v === null || type === 'string' || type === 'number'

    //             if (!isValid) {
    //                 console.error(`❌ Valor inválido en index ${i}:`, {
    //                     value: v,
    //                     type: type,
    //                     isArray: Array.isArray(v),
    //                     isObject: v !== null && type === 'object',
    //                     constructor: v?.constructor?.name,
    //                 })
    //             }
    //         })

    //         const invalidIndexes = values
    //             .map((v, i) => {
    //                 const type = typeof v
    //                 const isValid = v === null || type === 'string' || type === 'number'
    //                 return isValid ? -1 : i
    //             })
    //             .filter((i) => i !== -1)

    //         if (invalidIndexes.length > 0) {
    //             console.error('❌ CRITICAL: Valores inválidos encontrados:', invalidIndexes)
    //             console.error(
    //                 '❌ Detalles:',
    //                 invalidIndexes.map((i) => ({
    //                     index: i,
    //                     value: values[i],
    //                     type: typeof values[i],
    //                 })),
    //             )
    //             throw new Error(`Valores inválidos en indices: ${invalidIndexes.join(', ')}`)
    //         }

    //         console.log('✅ Todos los valores son válidos para SQLite')

    //         return new Promise((resolve, reject) => {
    //             database_next.transaction(
    //                 (tx) => {
    //                     tx.executeSql(
    //                         `INSERT OR REPLACE INTO ${USER_PROFILE} (
    //                             _id, name, last_name, email, user_name, role, avatar, timeZone, user_segment,
    //                             name_group, ws_url, delete_active, lat, lng, url_uploads, languages, lenguage,
    //                             phone, email_verified, phone_verified, cognito_id, login, image_splash,
    //                             last_update_coords, area, nickname, dni
    //                         ) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)`,
    //                         values,
    //                         () => {
    //                             console.log('✅ Usuario insertado correctamente')
    //                             resolve()
    //                         },
    //                         (_, err) => {
    //                             console.error('❌ Error adding user in transaction:', err)
    //                             console.error('❌ SQL:', 'INSERT OR REPLACE INTO user_profiles...')
    //                             console.error('❌ Values:', values)
    //                             console.error(
    //                                 '❌ Values types:',
    //                                 values.map((v) => typeof v),
    //                             )
    //                             reject(err)
    //                             return true
    //                         },
    //                     )
    //                 },
    //                 (err) => {
    //                     console.error('❌ Transaction error:', err)
    //                     reject(err)
    //                 },
    //             )
    //         })
    //     } catch (error) {
    //         console.error('❌ Error in addUser:', error)
    //         throw error
    //     }
    // }
}

export const getUser = async (db) => {
    if (isWeb()) {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([USER_PROFILE], 'readonly')
            const objectStore = transaction.objectStore(USER_PROFILE)
            const request = objectStore.getAll()

            request.onsuccess = () => {
                const users = request.result
                resolve(users.length > 0 ? users[0] : null)
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        })
    } else {
        try {
            const database = await createOrGetNativeDB()
            const user = await database.getFirstAsync(
                `SELECT * FROM ${USER_PROFILE} LIMIT 1`,
            )
            return user || null
        } catch (error) {
            console.error('Error getting user:', error)
            return null
        }
    }
}

export const updateUser = (db, user) => {
    return addUser(db, user) // Same as addUser for now
}

// Delete functions
export const deleteDatabase = async () => {
    try {
        console.log('(deleteDatabase) - Iniciando limpieza de base de datos...')

        // Get database instance
        const db = await getDatabaseAdapter()
        if (!db) {
            console.log('(deleteDatabase) - No hay instancia de base de datos')
            return
        }

        // Delete data from each table
        for (const table of TABLES_ARRAY) {
            try {
                await db.execAsync(`DELETE FROM ${table}`)
                console.log(`(deleteDatabase) - Tabla ${table} limpiada`)
            } catch (error) {
                // Table might not exist, continue
                console.log(
                    `(deleteDatabase) - Error al limpiar tabla ${table}:`,
                    error.message,
                )
            }
        }

        // Reset the database instance to force reinitialization
        database_instance = null
        native_initialized = false

        console.log('(deleteDatabase) - Base de datos limpiada exitosamente')
    } catch (error) {
        console.error('deleteDatabase - Error:', error)
    }
}

export const deleteDB = () => {
    return deleteDatabase() // Use the existing function
}

export const deleteAllTables = () => {
    return new Promise((resolve, reject) => {
        try {
            console.log(
                '⚠️  deleteAllTables temporarily stubbed for SDK 54 migration',
            )
            resolve()
        } catch (error) {
            reject(error)
        }
    })
}

export const deleteAllTablesContent = (_db) => {
    return new Promise((resolve, reject) => {
        try {
            console.log(
                '⚠️  deleteAllTablesContent temporarily stubbed for SDK 54 migration',
            )
            resolve()
        } catch (error) {
            reject(error)
        }
    })
}

export const deleteAllTablesLearning = async (_db) => {
    // Limpia TODAS las tablas relacionadas a Learning sin dropear el esquema
    // Web: limpia object stores; Native: ejecuta DELETE en cada tabla dentro de una transacción
    try {
        if (isWeb()) {
            const db = _db || database_instance
            if (!db) return

            // Verificación segura de objectStoreNames
            if (!db.objectStoreNames) {
                console.warn(
                    '[deleteAllTablesLearning] db.objectStoreNames is undefined, skipping cleanup',
                )
                return
            }

            const stores = [
                LEARNING_STORE_NAMES.CATEGORIES,
                LEARNING_STORE_NAMES.COURSES,
                LEARNING_STORE_NAMES.CONTENTS,
                LEARNING_STORE_NAMES.EVALUATIONS,
                // ANSWERS_EVALUATIONS se excluye: es historial de respuestas por dispositivo,
                // necesario para calcular score acumulado en reintentos offline
                LEARNING_STORE_NAMES.SAVE_PROGRESS_TRAINING,
            ].filter((name) => !!name && db.objectStoreNames.contains(name))

            if (stores.length === 0) return

            return new Promise((resolve, reject) => {
                const tx = db.transaction(stores, 'readwrite')
                let pending = stores.length
                let hasError = false

                const checkDone = () => {
                    if (pending === 0 && !hasError) resolve()
                }

                stores.forEach((storeName) => {
                    const req = tx.objectStore(storeName).clear()
                    req.onerror = (e) => {
                        hasError = true
                        reject(
                            e.target?.error ||
                                new Error(`Error clearing store ${storeName}`),
                        )
                    }
                    req.onsuccess = () => {
                        pending -= 1
                        checkDone()
                    }
                })

                tx.onerror = (e) => {
                    hasError = true
                    reject(
                        e.target?.error ||
                            new Error(
                                'IndexedDB transaction error while clearing learning stores',
                            ),
                    )
                }
                tx.oncomplete = () => {
                    pending = 0
                    checkDone()
                }
            })
        } else {
            const db = _db || (await createOrGetNativeDB())
            // Usar transacción con arreglo de statements (API del adapter)
            // ANSWERS_EVALUATIONS se excluye: es historial de respuestas por dispositivo,
            // necesario para calcular score acumulado en reintentos offline
            const statements = [
                { sql: `DELETE FROM ${LEARNING_STORE_NAMES.CATEGORIES};` },
                { sql: `DELETE FROM ${LEARNING_STORE_NAMES.COURSES};` },
                { sql: `DELETE FROM ${LEARNING_STORE_NAMES.CONTENTS};` },
                { sql: `DELETE FROM ${LEARNING_STORE_NAMES.EVALUATIONS};` },
                {
                    sql: `DELETE FROM ${LEARNING_STORE_NAMES.SAVE_PROGRESS_TRAINING};`,
                },
            ]
            await db.transactionAsync(statements)
        }
    } catch (error) {
        throw error
    }
}

export const deleteAllTablesBenefits = () => {
    return new Promise((resolve, reject) => {
        try {
            console.log(
                '⚠️  deleteAllTablesBenefits temporarily stubbed for SDK 54 migration',
            )
            resolve()
        } catch (error) {
            reject(error)
        }
    })
}

// Learning content functions
export const addLearningContent = () => Promise.resolve()
export const getLearningContent = () => Promise.resolve([])

// --- Migration helpers (minimal) ---
export const addColumnIfMissing = async (
    db,
    column_name,
    table_name,
    column_type = 'TEXT',
) => {
    try {
        if (
            column_type != 'TEXT' &&
            column_type != 'INTEGER' &&
            column_type != 'BOOLEAN' &&
            column_type != 'FLOAT'
        ) {
            return
        }
        if (!db) {
            // open current instance if not provided
            db = await createOrGetNativeDB()
        }
        // Check existing columns
        const columns = await db.getAllAsync(`PRAGMA table_info(${table_name});`)

        const exists = columns?.some?.((c) => c?.name === column_name)
        if (!exists) {
            await db.execAsync(
                `ALTER TABLE ${table_name} ADD COLUMN ${column_name} ${column_type};`,
            )
            console.log(`Column ${column_name} added to ${table_name}`)
        }
        return true
    } catch (error) {
        console.error('addColumnIfMissing ===> ', error)
        return false
    }
}

export const migrateDatabase = async (oldVersion) => {
    if (!oldVersion) {
        return
    }

    const db = await getDatabaseAdapter()
    if (!db) {
        console.log('(deleteDatabase) - No hay instancia de base de datos')
        return
    }

    try {
        const statements = []

        if (oldVersion < 16) {
            statements.push(
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN name_form TEXT;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN heladera BOOLEAN;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN create_refrigerator BOOLEAN;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN type_form TEXT;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN form_id_father TEXT;`,
                },
            )
        }
        if (oldVersion < 21) {
            statements.push({
                sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.CHECKIN} ADD COLUMN objectives TEXT;`,
            })
        }
        if (oldVersion < 22) {
            statements.push({
                sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN status_send INTEGER;`,
            })
        }
        if (oldVersion < 29) {
            statements.push({
                sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN date_finish TEXT;`,
            })
        }
        if (oldVersion < 31) {
            statements.push({
                sql: `ALTER TABLE ${USER_PROFILE} ADD COLUMN last_update_coords TEXT;`,
            })
        }
        if (oldVersion < 32) {
            statements.push({
                sql: `ALTER TABLE ${LEARNING_STORE_NAMES.CATEGORIES} ADD COLUMN category_index INTEGER;`,
            })
        }
        if (oldVersion < 32) {
            statements.push({
                sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.CHECKOUT} ADD COLUMN forms_view TEXT;`,
            })
        }
        if (oldVersion < 34) {
            statements.push({
                sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.SCHEDULES_ADVANCES} ADD COLUMN incidence_answer TEXT;`,
            })
        }
        if (oldVersion < 35) {
            statements.push(
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.STORES} ADD COLUMN organization_id TEXT;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.STORES} ADD COLUMN status_send INTEGER;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.SCHEDULES_POS} ADD COLUMN status_send INTEGER;`,
                },
            )
        }
        if (oldVersion < 36) {
            statements.push({
                sql: `ALTER TABLE ${USER_PROFILE} ADD COLUMN area TEXT;`,
            })
        }
        if (oldVersion < 38) {
            statements.push({
                sql: `ALTER TABLE ${USER_PROFILE} ADD COLUMN nickname TEXT;`,
            })
        }
        if (oldVersion < 39) {
            statements.push({
                sql: `ALTER TABLE ${USER_PROFILE} ADD COLUMN dni TEXT;`,
            })
        }
        if (oldVersion < 40) {
            statements.push({
                sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN day_unique_id TEXT;`,
            })
        }
        if (oldVersion < 41) {
            statements.push(
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN checkin_id TEXT;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.CHECKIN} ADD COLUMN formsIdsFqa TEXT;`,
                },
            )
        }
        if (oldVersion < 42) {
            statements.push({
                sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.STORES} ADD COLUMN frequency TEXT;`,
            })
        }
        if (oldVersion < 43) {
            statements.push(
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_PENDING_SYNC} ADD COLUMN store_id TEXT;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_PENDING_SYNC} ADD COLUMN checkin_id TEXT;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_PENDING_SYNC} ADD COLUMN can_send BOOLEAN DEFAULT 1;`,
                },
            )
        }
        if (oldVersion < 44) {
            tx.executeSql(
                `ALTER TABLE ${SCHEDULES_STORE_NAMES.STORES} ADD COLUMN topstore TEXT;`,
            )
            tx.executeSql(
                `ALTER TABLE ${SCHEDULES_STORE_NAMES.STORES} ADD COLUMN potencial TEXT;`,
            )

            statements.push(
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.STORES} ADD COLUMN topstore TEXT;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.STORES} ADD COLUMN potencial TEXT;`,
                },
            )
        }
        if (oldVersion < 45) {
            statements.push(
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_PERFECT_STORE} ADD COLUMN tags TEXT;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN scoreTotalQuestionsPonderarFloat FLOAT;`,
                },
                {
                    sql: `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} SET scoreTotalQuestionsPonderarFloat = scoreTotalQuestionsPonderar;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN scoreObtainedFloat FLOAT;`,
                },
                {
                    sql: `UPDATE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} SET scoreObtainedFloat = scoreObtained;`,
                },
            )
        }

        // Agregar columnas para almacenar desglose por key (scores agrupados)
        if (oldVersion < 58) {
            statements.push(
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN scoresByKey TEXT;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS_QUESTION_ANSWERS} ADD COLUMN totalByKey TEXT;`,
                },
            )
        }

        if (oldVersion < 46) {
            statements.push({
                sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS} ADD COLUMN weigh FLOAT;`,
            })
        }
        if (oldVersion < 47) {
            statements.push({
                sql: `ALTER TABLE ${USER_PROFILE} ADD COLUMN showClearCacheButton BOOLEAN;`,
            })
        }
        // if (oldVersion < 56) {
        //     // test_column
        //     // tx.executeSql(`ALTER TABLE ${USER_PROFILE} ADD COLUMN test_column TEXT;`)
        //     statements.push({ sql: `ALTER TABLE ${USER_PROFILE} ADD COLUMN test_column TEXT;` })
        // }
        if (oldVersion < 56) {
            statements.push({
                sql: `ALTER TABLE ${FOOTER_APP} ADD COLUMN footer_index INTEGER;`,
            })
        }
        if (oldVersion < 59) {
            statements.push(
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS} ADD COLUMN scores TEXT;`,
                },
                {
                    sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.FORMS} ADD COLUMN weights TEXT;`,
                },
            )
        }
        if (oldVersion < 57) {
            statements.push({
                sql: `ALTER TABLE ${postsStoreName} ADD COLUMN post_height INTEGER;`,
            })
        }
        if (oldVersion < 58) {
            statements.push({
                sql: `ALTER TABLE ${postsStoreName} ADD COLUMN comment_count INTEGER;`,
            })
        }

        if (oldVersion < 61) {
            statements.push({
                sql: `ALTER TABLE ${TABLE_NAME.LEARNING_EVALUATIONS} ADD COLUMN allow_partial_submission BOOLEAN;`,
            })

            statements.push({
                sql: `ALTER TABLE ${TABLE_NAME.LEARNING_EVALUATIONS} ADD COLUMN max_retry_attempts INTEGER;`,
            })

            statements.push({
                sql: `ALTER TABLE ${TABLE_NAME.LEARNING_EVALUATIONS} ADD COLUMN retry_only_failed BOOLEAN;`,
            })
        }

        if (oldVersion < 62) {
            statements.push({
                sql: `ALTER TABLE ${TABLE_NAME.LEARNING_EVALUATIONS} ADD COLUMN attempts_count INTEGER;`,
            })

            statements.push({
                sql: `ALTER TABLE ${TABLE_NAME.LEARNING_EVALUATIONS} ADD COLUMN failed_questions TEXT;`,
            })

            statements.push({
                sql: `ALTER TABLE ${TABLE_NAME.LEARNING_EVALUATIONS} ADD COLUMN partial_anmswers TEXT;`,
            })
        }

        if (oldVersion < 63) {
            statements.push({
                sql: `ALTER TABLE ${LEARNING_STORE_NAMES.ANSWERS_EVALUATIONS} ADD COLUMN status INTEGER DEFAULT 0;`,
            })
        }

        if (oldVersion < 64) {
            // Guarda el attempt_id activo mientras la evaluación está en curso (partial submissions)
            // Se limpia cuando la evaluación se completa o se reintenta
            statements.push({
                sql: `ALTER TABLE ${TABLE_NAME.LEARNING_EVALUATIONS} ADD COLUMN current_attempt_id TEXT;`,
            })
        }
        if (oldVersion < 65) {
            statements.push({
                sql: `ALTER TABLE ${SCHEDULES_STORE_NAMES.CHECKOUT} ADD COLUMN steps_distributor TEXT;`,
            })
        }

        // Ejecutar todas las migraciones en una transacción
        if (statements.length > 0) {
            console.log('statements de migracion: ', statements)
            await db.transactionAsync(statements)
            console.log(
                '✅ Migración completada exitosamente desde versión',
                oldVersion,
            )
        } else {
            console.log('ℹ️ No hay migraciones pendientes para versión', oldVersion)
        }
    } catch (error) {
        console.log('Error en la migracion de la base de datos', error)
        return 'Fallaste mal'
    }
}
